<template>
  <div class="wjAppointmentExamine">
    <!-- tab -->
    <div class="filters">
      <el-tag class="tabs" :effect="tabIndex==1?'dark':'light'" @click="changeTabs(1)">访客预约审核</el-tag>
      <el-tag class="tabs" :effect="tabIndex==2?'dark':'light'" @click="changeTabs(2)">货物配送审核</el-tag>
    </div>
    <el-card v-show="tabIndex==1">
      <el-form :inline="true">
        <el-form-item>
          <el-date-picker v-model="visitTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择到访日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="visitName" placeholder="请输入到访人姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="visitPhone" placeholder="请输入到访人电话"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="beVisitName" placeholder="请输入被访人姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="beVisitPhone" placeholder="请输入被访人电话"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="visitState" placeholder="审核状态">
            <el-option v-for="item in visitStateArr" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="getData">{{$t('lang.btn_search')}}</el-button>
        <el-button type="primary" @click="exportData">导出数据</el-button>
      </el-form>
      <el-table :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="visitTime" label="到访日期"></el-table-column>
        <el-table-column width="100" prop="inTime" label="到访时间"></el-table-column>
        <el-table-column prop="visitName" label="到访人姓名"></el-table-column>
        <el-table-column prop="visitPhone" label="到访人电话"></el-table-column>
        <el-table-column width="240" prop="visitUnit" label="到访人单位"></el-table-column>
        <el-table-column prop="beVisitName" label="被访人姓名"></el-table-column>
        <el-table-column prop="beVisitPhone" label="被访人电话"></el-table-column>
        <el-table-column prop="beVisitDepartment" label="被访人部门"></el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button class="green" @click="adopt(scope.row)" v-if="scope.row.state==1">通过</el-button>
            <el-button class="orange" @click="showdialog(scope.row.id)" v-if="scope.row.state==1">拒绝</el-button>
            <el-button v-if="scope.row.state==2" class="green">已通过</el-button>
            <el-button v-if="scope.row.state==3" class="orange">已拒绝</el-button>
            <el-button @click="goDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
        <el-input rows=4 type="textarea" v-model="refuseReason" placeholder="请输入拒绝原因"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="refuse()">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
    <el-card v-show="tabIndex==2">
      <el-form :inline="true">
        <el-form-item>
          <el-date-picker v-model="driverSubServiceTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择送达日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="driverName" placeholder="请输入司机姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="driverPhone" placeholder="请输入司机电话"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="driverReceiveName" placeholder="请输入接收人姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="driverReceivePhone" placeholder="请输入接收人电话"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="visitState1" placeholder="审核状态">
            <el-option v-for="item in visitStateArr" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="getData">{{$t('lang.btn_search')}}</el-button>
        <el-button type="primary" @click="exportData">导出数据</el-button>
      </el-form>
      <el-table :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="driverSubServiceTime" label="预计送达时间"></el-table-column>
        <el-table-column prop="driverName" label="司机姓名"></el-table-column>
        <el-table-column prop="driverPhone" label="司机电话"></el-table-column>
        <el-table-column prop="driverReceiveName" label="接收人姓名"></el-table-column>
        <el-table-column prop="driverReceivePhone" label="接收人电话"></el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button class="green" @click="adopt(scope.row)" v-if="scope.row.state==1">通过</el-button>
            <el-button class="orange" @click="showdialog(scope.row.id)" v-if="scope.row.state==1">拒绝</el-button>
            <el-button v-if="scope.row.state==2" class="green">已通过</el-button>
            <el-button v-if="scope.row.state==3" class="orange">已拒绝</el-button>
            <el-button @click="goDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
        <el-input rows=4 type="textarea" v-model="refuseReason" placeholder="请输入拒绝原因"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="refuse()">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:wjAppointmentExamine
   *@Description:万洁访客预约审批
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-03-19
   */
  import { mapGetters } from 'vuex'

  export default {
    name: '/manage/main.wjAppointmentExamine',
    data() {
      return {
        multipleSelection: [], // 多选框
        gardenId: this.$store.getters.gardenId, // 小区绑定值
        tableData: [], // list
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        dialogVisible: false, // 拒绝弹框
        refuseId: '', // 拒绝id
        refuseReason: '', // 拒绝原因
        visitTime: '', // 到访时间
        visitName: '', // 到访人姓名
        visitPhone: '', // 到访人电话
        beVisitName: '', // 被访人姓名
        beVisitPhone: '', // 被访人电话
        visitState: '', // 审核状态
        visitStateArr: [{
            label: '全部',
            value: 0
          }, {
            label: '待审核',
            value: 1
          },
          {
            label: '已通过',
            value: 2
          }, {
            label: '已拒绝',
            value: 3
          }
        ], // 审核状态arr
        tabIndex: 1, // tab切换序号 （人员1   车辆2）
        driverSubServiceTime: '', // 预计送达时间
        driverName: '', // 司机姓名
        driverPhone: '', // 司机电话
        driverReceiveName: '', // 接收人姓名
        driverReceivePhone: '', // 接收人电话
        visitState1: '', // 审核状态
      }
    },
    computed: {
      ...mapGetters({
        gardenId: 'gardenId'
      })
    },
    watch: {
      dialogVisible(newVal, oldVal) {
        if (newVal) {
          this.refuseReason = ''
        }
      }
    },
    created() {
      setTimeout(() => {
        window.localStorage.setItem('wjNewsform', '')
      }, 200)
      this.getData()
    },
    activated() {
      this.getData()
    },
    methods: {
      // 切换tab
      changeTabs(index) {
        this.tabIndex = index
        this.pageNo = 1
        this.pageSize = 10
        this.getData()
      },
      // 获取列表数据
      getData() {
        let loading = this.$loading()
        let params = {
          visitTime: this.tabIndex == 1 ? this.visitTime : '',
          visitName: this.tabIndex == 1 ? this.visitName : '',
          visitPhone: this.tabIndex == 1 ? this.visitPhone : '',
          beVisitName: this.tabIndex == 1 ? this.beVisitName : '',
          beVisitPhone: this.tabIndex == 1 ? this.beVisitPhone : '',
          driverSubServiceTime: this.tabIndex == 2 ? this.driverSubServiceTime : '',
          driverName: this.tabIndex == 2 ? this.driverName : '',
          driverPhone: this.tabIndex == 2 ? this.driverPhone : '',
          driverReceiveName: this.tabIndex == 2 ? this.driverReceiveName : '',
          driverReceivePhone: this.tabIndex == 2 ? this.driverReceivePhone : '',
          state: this.tabIndex == 1 ? this.visitState : this.visitState1,
          subType: this.tabIndex,
          gardenId: this.gardenId
        }

        console.log(params)
        this.$get(`/wjSubscribe?pageNo=${this.pageNo}&pageSize=${this.pageSize}`, params).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 审核通过
      adopt(row) {
        console.log(row)
        let loading = this.$loading()
        let params = {
          state: 2
        }
        this.$confirm('通过该访客预约申请？', '提示', {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'success'
          }).then(() => {
            this.$patch(`/wjSubscribe/${row.id}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  console.log(res)
                  this.getData()
                  this.$message({
                    type: 'success',
                    message: '已通过审批'
                  })
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              })
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: '已取消审批'
            })
          })
      },
      // 审核不通过
      refuse() {
        if (this.refuseReason == '') {
          this.$message({
            type: 'info',
            message: '请输入拒绝原因'
          })
        } else {
          let loading = this.$loading()
          let params = {
            state: 3,
            checkInfo: this.refuseReason
          }
          this.$patch(`/wjSubscribe/${this.refuseId}`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.getData()
                this.dialogVisible = false
                this.$message({
                  type: 'error',
                  message: '已拒绝审批'
                })
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            })
        }
      },
      // 显示拒绝弹窗
      showdialog(id) {
        this.dialogVisible = true
        this.refuseId = id
      },
      // 详情
      goDetail(rowData) {
        this.$router.push({
          name: this.tabIndex == 1 ? 'wjAppointmentExamineEdit' : 'wjAppointmentExamineEdit1',
          query: {
            object: rowData
          }
        })
      },
      // 更新
      commit() {
        this.pageNo = 1
        this.getData()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      // 导出数据
      exportData() {
        let loading = this.$loading()
        let params = {
          visitTime: this.tabIndex == 1 ? this.visitTime : '',
          visitName: this.tabIndex == 1 ? this.visitName : '',
          visitPhone: this.tabIndex == 1 ? this.visitPhone : '',
          beVisitName: this.tabIndex == 1 ? this.beVisitName : '',
          beVisitPhone: this.tabIndex == 1 ? this.beVisitPhone : '',
          driverSubServiceTime: this.tabIndex == 2 ? this.driverSubServiceTime : '',
          driverName: this.tabIndex == 2 ? this.driverName : '',
          driverPhone: this.tabIndex == 2 ? this.driverPhone : '',
          driverReceiveName: this.tabIndex == 2 ? this.driverReceiveName : '',
          driverReceivePhone: this.tabIndex == 2 ? this.driverReceivePhone : '',
          state: this.tabIndex == 1 ? this.visitState : this.visitState1,
          subType: this.tabIndex,
          gardenId: this.gardenId
        }

        console.log(params)
        this.$get(`/wjSubscribeExport`, params).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              window.open(res.webUrl)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      }
    }
  }
</script>

<style lang="scss">
  .tabs {
    font-size: 18px;
    margin-right: 20px;
  }
</style>